<template>
	<FormGroupBox
		v-if="modelId > 0"
		title="Bird ID"
	>
		<b-form-row v-if="birdContact.birdId" class="d-flex flex-column align-items-center">
			<b-overlay no-wrap :show="loading" />
			<b-form-group class="col-12 text-center mb-0" v-if="!loading" :disabled="true" >
                <b-form-input v-model="birdContact.birdId" size="sm"></b-form-input>
			</b-form-group>
			<div class="">
				<b-button variant="link" class="m-0 p-0 d-flex" @click="fetch()"><small >Actualizar</small></b-button>
			</div>
		</b-form-row>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import api from "@/api.js";

export default {
	props:{
		modelId: Number
	},
	components: {
		FormGroupBox,
	},
    data(){
		return{
			birdContact:{birdId:null},
            loading:false
		}
	},
    methods: {
        fetch(){
			this.loading=true;
            api(this)
            .get(`/reservation/${this.modelId}/json/resources/bird-contact`)
            .then((data) => {
                this.birdContact = data.data;
            })
            .finally(()=>{
                this.loading=false
            })
        },
    },
   
    mounted(){
        this.fetch();
    }
};
</script>
